import React from 'react';
import Images from '../../static'
import { EXTERNAL_URL } from 'src/shared/config/src';
type IProps = {
  showFooterLinks?: boolean,
  isVersion?: boolean
}

const Footer: React.FC<IProps> = ({ showFooterLinks = true, isVersion = false }) => {
  return (
    <div className="footer-wrapper pd-y-8">
      <div className="footer-logo text-center d-flex align-items-center justify-content-center">
        <img src={Images.footerLogo} alt="logo" />
      </div>
      {showFooterLinks  ?
        <div className='d-flex justify-content-center align-items-center gap-2 mt-1'>
          <div className='border-end border-dark pe-2 lh-11'>
            <a href={EXTERNAL_URL.TnC} className='fs-10 text-black' target="_blank" rel="noreferrer">
              Terms & Condition
            </a>
          </div>
          <div className='border-end border-dark pe-2 lh-11'>
            <a href={EXTERNAL_URL.PRIVACY_POLICY} className='fs-10 text-black' target="_blank" rel="noreferrer">
              Privacy Policy
            </a>
          </div>
          <div className='lh-11'>
            <a href={EXTERNAL_URL.GDPR} className='fs-10 text-black' target="_blank" rel="noreferrer">
              GDPR
            </a>
          </div>
        </div>
      : null}
    </div>
  )
};

export default Footer;